import React, {ReactNode} from "react";

export default function HFInput({type, name, value, onChange, placeholder, label, tips = null}: {
    type: string,
    name: string,
    value: string,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    placeholder: string,
    label: string | undefined,
    tips?: ReactNode
}) {
    if (label) {
        return (
            <div className="labeled-input">
                <div className="label-group">
                    <label htmlFor={name} className="label">{label}</label>
                    <div className="tips">{tips}</div>
                </div>

                <input type={type} id={name} name={name} value={value} onChange={onChange} className="input"
                       placeholder={placeholder}/>
            </div>
        );
    } else {
        return (
            <input type={type} id={name} name={name} value={value} onChange={onChange} className="input"
                   placeholder={placeholder}/>
        );
    }
}